import React from "react";
import { workshopFormats } from "../data";
import SectionHead from "./SectionHead";
import WorkshopCard from "./WorkshopCard";

const WorkshopGrid = () => (
  <section
    className="workshops-section"
    id="workshops"
    aria-labelledby="workshops-heading"
  >
    <div className="container">
      <SectionHead
        headingId="workshops-heading"
        title={
          <>
            Three formats. <em>One outcome.</em>
          </>
        }
        body="Half-day, full-day or up to three days. Pick the one that fits, we'll tailor it to your team and goals before we arrive."
      />
      <div className="workshops-grid">
        {workshopFormats.map((workshop) => (
          <WorkshopCard key={workshop.id} workshop={workshop} />
        ))}
      </div>
    </div>
  </section>
);

export default WorkshopGrid;
